import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isEmpty } from 'lodash';
import { FormControlType, FormGroupComponent } from '../../../../forms';
import { AbstractFilterEngineFormComponent } from '../abstract-filter-form.component';

@Component({
  selector: 'iot-platform-ui-filter-text-field',
  standalone: true,
  imports: [FormGroupComponent],
  template: `<iot-platform-ui-form-group data-cy="iot-platform-ui-filter-text-field" [fields]="fields()" [group]="form" />`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterTextFieldComponent extends AbstractFilterEngineFormComponent<string> {
  getValueDisplay() {
    return this.getControlValue() ?? '';
  }

  getControlValue() {
    const value = this.searchTermControl?.getRawValue();
    return value?.trim() || null;
  }

  hasValidValue() {
    return !isEmpty(this.getControlValue());
  }

  getSearchFields() {
    return [
      {
        ...this.searchTermField,
        type: FormControlType.TEXT
      }
    ];
  }
}
